export const iconFontAwesomeHouseholdJugDetergent = (
	<i className="fa-solid fa-jug-detergent"></i>
);
